<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';

    export let icon: UIcons;
    export let color = 'inherit';
    export let label: string | null = null;
    export let lineHeight = 'inherit';
    export let additionalClasses = '';
</script>

{#if label}
    <span class="uicon fi-br-{icon} {additionalClasses}"
          style="--color: {color}; --lineHeight: {lineHeight};"
          aria-label="{label}"
          title="{label}">
    </span>
{:else}
    <span class="uicon fi-br-{icon} {additionalClasses}"
          style="--color: {color}; --lineHeight: {lineHeight};"
          aria-hidden="true">
    </span>
{/if}

<style lang="less">
    .uicon {
        line-height: var(--lineHeight);
        color: var(--color);
        display: inline-flex;
        align-items: center;

        &:before {
            line-height: var(--lineHeight);
        }
    }
</style>